module.exports = __webpack_public_path__ + "img/age03.8a8e232b.png";